import { useCallback } from 'react';
import { usePriceListDeleteMutation } from 'api';
import { notification } from 'components';
import { ErrorMappingValueType } from 'typings';
import { IDeleteItem } from 'feature/supplierTabs/priceList/usePriceList';

export const useDeleteModal = (onDeleteModalClose: () => void) => {
  const [notificationApi, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = useCallback(
    (messageContent: ErrorMappingValueType) => {
      const { type, message } = messageContent;
      notificationApi[type]({
        message: message,
      });
    },
    [notificationApi]
  );

  const [priceListDelete, { isLoading: priceListDeleteIsLoading }] = usePriceListDeleteMutation();
  // const [priceListFileDelete, { isLoading: fileDeleteIsLoading }] = useSupplierFileDeleteMutation();

  const handleErrors = useCallback(
    (error: any) => {
      if (!error?.data?.success && error?.data?.data) {
        Object.values(error.data.data).forEach((message) => {
          openNotificationWithIcon({
            type: 'error',
            message: message as string,
          });
        });
      } else {
        openNotificationWithIcon({
          type: 'error',
          message: 'Something went wrong!',
        });
      }
    },
    [openNotificationWithIcon]
  );
  const onRemoveConfirm = useCallback(
    async (priceList: IDeleteItem | undefined) => {
      if (priceList?.id) {
        try {
          const response = await priceListDelete({
            id: priceList.id,
          });
          if (response?.data?.success) {
            // const fileResponse = await priceListFileDelete({
            //   supplierId: priceList.supplierId,
            //   priceListId: priceList.id,
            //   name: priceList.fileName,
            // });

            // TODO what if the error occurs during file deletion
            // if (fileResponse?.data?.success) {
            //   openNotificationWithIcon({
            //     type: 'success',
            //     message: 'Pricelist was successfully deleted.',
            //   });
            //   onDeleteModalClose();
            // } else {
            //   handleErrors(fileResponse.error);
            // }
            openNotificationWithIcon({
              type: 'success',
              message: 'Pricelist was successfully deleted.',
            });
            onDeleteModalClose();
          } else {
            handleErrors(response.error);
          }
        } catch (err) {
          handleErrors(err);
        }
      }
    },
    [priceListDelete, onDeleteModalClose, openNotificationWithIcon, handleErrors]
  );

  return {
    onRemoveConfirm,
    contextHolder,
    isLoading: priceListDeleteIsLoading,
  };
};
